export default {"src":"/_next/static/media/cxBrand1.13d6aa9a.svg","height":57,"width":66,"blurWidth":0,"blurHeight":0};